import { ConfirmationClaimType } from '../confirmation-claims.enum';
import { AuthorisationFlowType, ConfirmationPreferenceTypes } from '../workflow.v2.type';

export const confirmationClaimsConstants = [
  ConfirmationClaimType.ADD_BENEFICIARY,
  ConfirmationClaimType.DELETE_BENEFICIARY,
  ConfirmationClaimType.UPDATE_BENEFICIARY,
  ConfirmationClaimType.MAKE_PAYMENT,
  ConfirmationClaimType.GET_SENSITIVE_CARD_DETAILS,
  ConfirmationClaimType.GET_EPIN,
  ConfirmationClaimType.ADD_CARD,
  ConfirmationClaimType.CANCEL_PAYMENT,
];

export const defaultConfirmationPreferences: ConfirmationPreferenceTypes[] = [
  ConfirmationPreferenceTypes.APP_PIN,
  ConfirmationPreferenceTypes.BIOMETRICS,
  ConfirmationPreferenceTypes.TOTP,
  ConfirmationPreferenceTypes.SMS_OTP,
  ConfirmationPreferenceTypes.EMAIL_OTP,
];

export const defaultAuthoriseFlowConfirmationPreferences = {
  [AuthorisationFlowType.LOGIN]: {
    confirmationPreferenceOrder: [],
  },
  [AuthorisationFlowType.ALL_OTHER_FLOWS]: {
    confirmationPreferenceOrder: [],
    beneficiaryConfirmationEnabled: false,
  },
};
